import { GameConstants } from "./GameConstants";
import { AudioManager } from "./AudioManager";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import { SplashScene } from "./scenes/splash/SplashScene";
import { GameVars } from "./GameVars";
import MockAPI from "./api/MockGameAPI";
import * as Candy from "@ravalmatic/candy-engine";
import { Game } from "phaser";
import { BoardManager } from "./scenes/board-scene/BoardManager";
//import { JsonRpc } from "eosjs";

export class GameManager {

    public static init(): void {

        GameVars.development = process.env.NODE_ENV === "development";
        
        GameVars.intitialised = true;
        GameVars.oneMoveBack = false;
        GameVars.speedFactor = 1;

        const gameKey = "701d8045487bad0dabda5cb99e9c343f";
        const secretKey = "9a40cc4ba40126154bf1292862992bdf720625cb";

        GameVars.gameAnalytics = require("gameanalytics");
        GameVars.gameAnalytics.GameAnalytics.initialize(gameKey, secretKey);

        if (GameVars.currentScene.sys.game.device.os.desktop) {

            GameVars.scaleY = 1;

        } else {

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            const aspectRatio = window.innerHeight / window.innerWidth;
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
        }

        window["GD_OPTIONS"] = {
            "gameId": "d14b451d28ee48acb30849bc65519e6c",
            "onEvent": function(event) {
                switch (event.name) {
                    case "SDK_GAME_START":
                        if (!GameVars.gameData.muted) {
                            AudioManager.howl.mute(false);
                        }
                        switch (GameVars.addType) {
                            case GameConstants.ADD_ENTER_GAME: {
                                GameManager.startGame();
                            break; }
                            case GameConstants.ADD_PLAY: {
                                GameManager.onClickPlaySplash();
                            break; }
                            case GameConstants.ADD_RESET: {
                                GameManager.resetGame();
                            break; }
                            case GameConstants.ADD_RESUME: {
                                BoardManager.currentInstance.resume();
                            break; }
                        }
                        GameVars.addType = 0;
                        break;
                    case "SDK_GAME_PAUSE":
                        AudioManager.howl.mute(true);
                        break;
                    case "SDK_GDPR_TRACKING":
                        // this event is triggered when your user doesn't want to be tracked
                        break;
                    case "SDK_GDPR_TARGETING":
                        // this event is triggered when your user doesn't want personalised targeting of ads and such
                        break;
                }
            },
        };
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://html5.api.gamedistribution.com/main.min.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'gamedistribution-jssdk'));

        GameManager.readGameData();
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        highScore: 0,
                        language: "en"
                    };
                }

                let w = <any> window;
                if (typeof w.gdsdk !== 'undefined' && w.gdsdk.showAd !== 'undefined') {
                    GameVars.addType = GameConstants.ADD_ENTER_GAME;
                    w.gdsdk.showAd();
                }
                else {
                    GameManager.startGame();
                }
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();

        GameVars.gameText = GameVars.currentScene.cache.json.get("game-text");

        if (GameConstants.DEBUG_MODE) {
            GameManager.enterBoardScene();
        } else {
            GameManager.enterSplashScene();
        }
    }

    public static enterReplayScene(): void  {

        GameVars.currentScene.scene.start("ReplayScene");
    }

    public static enterSplashScene(): void  {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static async onClickPlaySplash(): Promise<void> {

        GameManager.enterBoardScene();
    }

    public static onLoginSuccess(): void {

        GameManager.enterBoardScene();
    }

    public static enterBoardScene(forcedCombo?: string): void {

        GameVars.forcedCombo = forcedCombo || null;

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static resetGame(): void {

        GameManager.enterBoardScene();
    }

    public static resetReplay(): void {

        GameManager.enterReplayScene();
    }

    public static onBothOrbsSelected(): void {

        GameVars.iPRNG = GameVars.candyEngine.prng.i;
        GameVars.previousBoard = GameManager.cloneOrbs(GameVars.candyEngine.board);
        GameVars.numOrbs = GameVars.candyEngine.numOrbs;
    }

    public static getTimeUntilEndOfDay(): number {

        const d = new Date();
        const h = d.getUTCHours();
        const m = d.getUTCMinutes();
        const s = d.getUTCSeconds();

        return (24 * 60 * 60) - (h * 60 * 60) - (m * 60) - s;
    }

    public static back(): void {

        GameVars.oneMoveBack = true;

        GameVars.currentScene.scene.start("BoardScene");
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static toggleOrbsSpeed(): void {

        GameVars.speedFactor = GameVars.speedFactor === 1 ? .1 : 1;
    }

    public static logBoard(str?: boolean): void {

        const board = GameVars.candyEngine.board;

        if (str) {

            const orbIDs: number[][] = [];
            const orbTypes: number[][] = [];

            for (let c = 0; c < GameVars.cols; c ++) {
                orbIDs.push([]);
                for (let r = 0; r < GameVars.rows; r ++) {
                    orbIDs[c][r] = board[c][r].color;
                }
            }

            for (let c = 0; c < GameVars.cols; c ++) {
                orbTypes.push([]);
                for (let r = 0; r < GameVars.rows; r ++) {
                    orbTypes[c][r] = board[c][r].type;
                }
            }

            console.log(JSON.stringify(orbIDs));
            console.log(JSON.stringify(orbTypes));
            console.log("iPRNG:", GameVars.candyEngine.prng.i);
            console.log("numOrbs:", GameVars.candyEngine.numOrbs);

        } else {

            for (let r = 0; r < GameVars.rows; r ++) {

                let str = "";
    
                for (let c = 0; c < GameVars.cols; c ++) {
    
                    if (board[c][r].color === -1) {
                        str += "| " + "*";
                    } else {
                        str += "| " + board[c][r].color;
                    }
                }
    
                console.log(str);
            }
        }
    }

    public static cloneOrbs(orbs: Candy.OrbData[][]): Candy.OrbData[][] {

        const clonedOrbs: Candy.OrbData[][] = [];

        const cols = orbs.length;
        const rows = orbs[0].length;

        for (let c = 0; c < cols; c ++) {
            clonedOrbs.push([]);
            for (let r = 0; r < rows; r ++) {
                clonedOrbs[c][r] = {id: orbs[c][r].id, color: orbs[c][r].color, type: orbs[c][r].type, prevPos: orbs[c][r].prevPos, mutated: orbs[c][r].mutated, removed: orbs[c][r].removed};
            }
        }
   
        return clonedOrbs;
    }

    public static generateBoardFromString(colorStr: string, typesStr?: string): Candy.OrbData[][] {

        const orbs: Candy.OrbData[][] = [];

        const tmpColours = JSON.parse(colorStr);

        let tmpTypesMatrix: number [][] = [];

        if (typesStr) {
            tmpTypesMatrix = JSON.parse(typesStr);
        }

        const cols = tmpColours.length;
        const rows = tmpColours[0].length;

        for (let c = 0; c < cols; c ++) {
            orbs.push([]);
            for (let r = 0; r < rows; r ++) {

                if (tmpTypesMatrix.length > 0) {
                    orbs[c].push({id: c * rows + r, color: tmpColours[c][r], type: tmpTypesMatrix[c][r], prevPos: {c: c, r: r}, mutated: false, removed: false});
                } else {
                    orbs[c].push({id: c * rows + r, color: tmpColours[c][r], type: 0, prevPos: {c: c, r: r}, mutated: false, removed: false});
                }
            }
        }

        return orbs;
    }

    private static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }
    
    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
